import {
  Button,
  Form,
  Input,
  Space,
  Typography,
  Modal,
  Card,
  Divider,
  Row,
  Col,
} from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
import GetBinService from "../../../services/Wash-service/GetBinService";
import BarcodeScanner from "../../Comman/Scanner/BarCodeScanner";
import "../../../styles/global-ui.css";

const { Text, Title } = Typography;

const GetBin = ({ userData }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleTagClick = () => {
    if (isLoading) return;
    setIsModalVisible(true);
  };

  const handleScan = (value) => {
    setIsModalVisible(false);
    onFinish({ binId: value });
  };

  const handleScanError = (error) => {
    ResponseMessage.error({
      message:
        "Error accessing camera. Please try manual input or check camera permissions.",
    });
    console.error(error);
  };

  const onFinish = async (values) => {
    try {
      const dataToSubmit = (values?.binId || values || "").trim();

      if (!dataToSubmit) {
        ResponseMessage.error({
          message: "Please provide valid scanned data or enter it manually",
        });
        return;
      }

      setIsSubmitted(true);
      setIsLoading(true);

      const response = await GetBinService.ViewBinbyId(dataToSubmit);

      if (
        response?.status &&
        Array.isArray(response?.data) &&
        response.data.length > 0
      ) {
        navigate(`/view/bin?binId=${encodeURIComponent(dataToSubmit)}`);
        return;
      }

      ResponseMessage.error({
        message: response?.message || "Bin Not Found",
      });
      setIsSubmitted(false);
      setIsLoading(false);
      form.setFieldsValue({ binId: dataToSubmit });
    } catch (error) {
      console.error("Error:", error);
      ResponseMessage.error({
        message: "An error occurred while fetching data.",
      });
      setIsSubmitted(false);
      setIsLoading(false);
    }
  };

  return (
    <>
      <Card
        className="modern-card dashboard-filter-wrap"
        style={{ marginBottom: 20 }}
      >
        <div className="compact-stats">
          <Row gutter={[16, 8]} justify="center">
            <Col xs={24} sm={8}>
              <div className="compact-stat-item">
                <div
                  className="compact-stat-value"
                  style={{ color: "#0f172a" }}
                >
                  Scan
                </div>
                <div className="compact-stat-label">Use camera scanner</div>
              </div>
            </Col>

            <Col xs={24} sm={8}>
              <div className="compact-stat-item">
                <div
                  className="compact-stat-value"
                  style={{ color: "#0f766e" }}
                >
                  Or
                </div>
                <div className="compact-stat-label">Manual entry option</div>
              </div>
            </Col>

            <Col xs={24} sm={8}>
              <div className="compact-stat-item">
                <div
                  className="compact-stat-value"
                  style={{ color: "#7c3aed" }}
                >
                  View
                </div>
                <div className="compact-stat-label">Open bin details</div>
              </div>
            </Col>
          </Row>
        </div>
      </Card>

      <Card className="modern-card">
        <div
          style={{
            maxWidth: 420,
            margin: "0 auto",
            padding: "12px 0",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 20,
            }}
          >
            <div
              className="dashboard-stat-card bg-card-blue"
              style={{
                minHeight: 100,
                width: "100%",
                maxWidth: "320px",
                cursor: isLoading ? "not-allowed" : "pointer",
                opacity: isLoading ? 0.7 : 1,
              }}
              onClick={handleTagClick}
            >
              <div
                className="dashboard-stat-card-inner"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <div className="dashboard-stat-title">SCAN BIN</div>
                <Text style={{ color: "#475569", fontSize: 13 }}>
                  Tap to open scanner
                </Text>
              </div>
            </div>

            <Space size="large">
              <Text strong style={{ color: "#64748b", fontSize: 14 }}>
                OR
              </Text>
            </Space>

            <Form
              name="form_item_path"
              layout="vertical"
              onFinish={onFinish}
              form={form}
              style={{ width: "100%", maxWidth: "320px" }}
            >
              <Form.Item
                name="binId"
                label="Enter Bin ID Manually"
                rules={[
                  {
                    required: true,
                    message: "Bin ID cannot be empty. Please provide a valid ID.",
                  },
                ]}
              >
                <Input
                  autoFocus
                  size="large"
                  placeholder="Enter Bin ID"
                  disabled={isLoading}
                  style={{
                    width: "100%",
                    textAlign: "center",
                    borderRadius: 10,
                  }}
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    disabled={isSubmitted}
                    size="large"
                    className="primary-btn"
                    style={{
                      minWidth: 140,
                      borderRadius: 10,
                      fontWeight: 600,
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Card>

      <Modal
        title="Scan QR Code"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        centered
      >
        <BarcodeScanner onScan={handleScan} onError={handleScanError} />
      </Modal>
    </>
  );
};

export default GetBin;